import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Button } from "..";
import { Modal as RSModal } from "rsuite";
const Modal = (props) => {
    const { size, open, setOpen, children, header, actionButton, className, onEnter, onExited } = props;
    const closeButton = props.closeButton ?? true;
    const rsOverflow = props.overflow !== false;
    const handleClose = () => {
        setOpen(false);
    };
    return (_jsx(_Fragment, { children: _jsxs(RSModal, { overflow: rsOverflow, open: open, onClose: handleClose, 
            /* @ts-ignore */
            size: size, className: className, onEnter: onEnter, onExited: onExited, children: [_jsx(RSModal.Header, { closeButton: false, children: header }), _jsx(RSModal.Body, { children: children }), _jsxs(RSModal.Footer, { children: [actionButton && (_jsx("span", { style: { margin: "6px" }, children: actionButton })), closeButton && (_jsx(Button, { type: "error", onClick: handleClose, icon: "xmark", position: "right" }))] })] }) }));
};
export default Modal;
